import { useState } from 'react';
import { etiquetaRol } from '../lib/roles';

// "Angel Aaron · Admin Supremo". El rol se ve SIEMPRE: evita el 90% de las
// dudas de permisos.
// CUENTA C3 (13 sep 2026): el chip es un BOTÓN que abre «Mi cuenta» cuando
// se le pasa `onAbrir`. Sin él sigue siendo el chip de siempre.
// CON FOTO (19 sep 2026): si la persona subió una en «Mi cuenta», el
// círculo la enseña; si no —o si la imagen no llega—, la inicial de
// siempre. `sello` cambia al subir o quitar, para que el navegador no
// sirva la anterior de su caché.
export default function ChipUsuario({ nombre, rol, onAbrir, tieneFoto = false, sello = 0 }) {
  const Etiqueta = onAbrir ? 'button' : 'div';
  // Si la imagen no llega se recuerda CON QUÉ sello falló: un sello nuevo
  // (otra foto) vuelve a intentarlo solo, sin efectos ni recargas.
  const [rotaEn, setRotaEn] = useState(null);
  const conFoto = tieneFoto && rotaEn !== sello;
  return (
    <Etiqueta
      {...(onAbrir ? { type: 'button', onClick: onAbrir, title: 'Mi cuenta', 'aria-label': `Mi cuenta: ${nombre || ''}` } : {})}
      className={`flex items-center gap-2 bg-gray-100 rounded-full pl-3 pr-1 py-1 ${onAbrir ? 'hover:bg-gray-200 cursor-pointer' : ''}`}
    >
      <div className="text-right leading-tight hidden sm:block">
        <div className="text-xs font-semibold text-gray-900 max-w-[9rem] truncate">{nombre}</div>
        <div className="text-[10px] text-gray-500">{etiquetaRol(rol)}</div>
      </div>
      <div className="h-7 w-7 rounded-full bg-[var(--color-marca)] text-white flex items-center justify-center text-xs font-bold shrink-0 overflow-hidden">
        {conFoto
          ? <img src={`/api/cuenta/foto/mia?v=${sello}`} alt="" className="h-full w-full object-cover" onError={() => setRotaEn(sello)} />
          : (nombre || '?').charAt(0).toUpperCase()}
      </div>
    </Etiqueta>
  );
}
